import { FC, useEffect, useState } from 'react';

import hexomaticLogo from 'images/logos/hexomatic-logo.svg';
import hexowatchLogo from 'images/logos/hexowatch-logo.svg';
import hexometerLogo from 'images/logos/hexometer-logo.svg';
import hexofyLogo from 'images/logos/hexofy-logo.svg';

import { setItemToLocalStorage } from 'helpers';

import Tooltip from 'components/molecule/tooltip';

import { sidebarCloseIcon, rightSidebarCloseIcon } from 'images/svg-icons';
import './styles.scss';

interface RightIconsSidebarProps {
  rightToggle: boolean;
  setRightToggle: (value: any) => void;
  headerHeight: number | null;
  navElH: number | null;
  hexometerPlan?: string;
}

const RightIconsSidebar: FC<RightIconsSidebarProps> = ({
  rightToggle,
  setRightToggle,
  headerHeight,
  navElH,
  hexometerPlan = 'FREE',
}) => {
  const [rightMenuSettings, setRightMenuSettings] = useState([
    { icon: hexomaticLogo, href: 'https://dash.hexomatic.com', product: 'Hexomatic' },
    { icon: hexowatchLogo, href: 'https://dash.hexowatch.com', product: 'Hexowatch' },
    // { icon: hexometerLogo, href: 'https://dash.hexometer.com', product: 'Hexometer' },
    { icon: hexofyLogo, href: 'https://hexofy.com', product: 'Hexofy' },
  ]);
  const handleSideBarClose = () => {
    setRightToggle((prev: any) => !prev);
    setItemToLocalStorage('products-sidebar', !rightToggle);
  };

  // useEffect(() => {
  //   if (!hexometerPlan || hexometerPlan === 'FREE') {
  //     setRightMenuSettings([
  //       { icon: hexomaticLogo, href: 'https://dash.hexomatic.com', product: 'Hexomatic' },
  //       { icon: hexowatchLogo, href: 'https://dash.hexowatch.com', product: 'Hexowatch' },
  //       { icon: hexometerLogo, href: 'https://hexometer.com/pricing/', product: 'Hexometer' },
  //       { icon: hexofyLogo, href: 'https://hexofy.com', product: 'Hexofy' },
  //     ]);
  //   } else {
  //     setRightMenuSettings([
  //       { icon: hexomaticLogo, href: 'https://dash.hexomatic.com', product: 'Hexomatic' },
  //       { icon: hexowatchLogo, href: 'https://dash.hexowatch.com', product: 'Hexowatch' },
  //       { icon: hexometerLogo, href: 'https://dash.hexometer.com', product: 'Hexometer' },
  //       { icon: hexofyLogo, href: 'https://hexofy.com', product: 'Hexofy' },
  //     ]);
  //   }
  // }, [hexometerPlan]);

  return (
    <div className={`r-navbar ${rightToggle ? 'r-show-sidebar' : 'r-show-mobile'}`}>
      <nav className="r-nav">
        <div style={{ paddingTop: headerHeight ? headerHeight - 17 : 44 }}>
          {rightMenuSettings.map(
            obj =>
              obj && (
                <Tooltip key={obj?.href} trigger={['hover', 'focus']} placement="left" text={obj?.product}>
                  <a
                    className={`r-nav__link ${obj?.product}`}
                    href={obj?.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={obj?.icon} alt={`${obj?.product} logo`} width="33px" height="33px" />
                  </a>
                </Tooltip>
              ),
          )}
        </div>

        <div className={`${rightToggle ? '' : 'collapsed'} r-sidebar-collapse`}>
          <button
            style={{
              top: navElH ? `calc(${navElH}px / 2 - ${31}px)` : 'calc(100vh / 2 - 60px)',
            }}
            onClick={handleSideBarClose}
            className="r-sidebar-collapse-button"
          >
            {rightToggle ? rightSidebarCloseIcon : sidebarCloseIcon}
          </button>
        </div>
      </nav>
    </div>
  );
};

export default RightIconsSidebar;
